
import { EtsyOrder } from "@/types/etsy";

const CACHE_KEY = 'etsy_orders_cache';
const CACHE_TIMESTAMP_KEY = 'etsy_orders_timestamp';
const PRODUCTS_CACHE_KEY = 'etsy_products_cache';
const PRODUCTS_TIMESTAMP_KEY = 'etsy_products_timestamp';

// Orders cache functions
export const getCachedOrders = (): EtsyOrder[] => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (!cached) return [];
    return JSON.parse(cached);
  } catch (error) {
    console.error('Error reading cached orders:', error);
    return [];
  }
};

export const setCachedOrders = (orders: EtsyOrder[]) => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(orders));
    localStorage.setItem(CACHE_TIMESTAMP_KEY, new Date().toISOString());
    console.log(`Cached ${orders.length} orders`);
  } catch (error) {
    console.error('Error caching orders:', error);
  }
};

export const clearCache = () => {
  // Clear all cache keys
  const keysToRemove = [
    CACHE_KEY,
    CACHE_TIMESTAMP_KEY,
    PRODUCTS_CACHE_KEY,
    PRODUCTS_TIMESTAMP_KEY,
    'selectedEtsyStoreIds',
    'supabase_user_data',
    'supabase_user_timestamp'
  ];
  
  keysToRemove.forEach(key => localStorage.removeItem(key));
  
  // Also clear any other potential cache keys that might contain user data
  const allKeys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.includes('supabase') || key.includes('etsy') || key.includes('auth'))) {
      allKeys.push(key);
    }
  }
  allKeys.forEach(key => localStorage.removeItem(key));
  
  console.log('Cleared all cache data');
};

export const shouldFetchOrders = (): boolean => {
  const timestamp = localStorage.getItem(CACHE_TIMESTAMP_KEY);
  if (!timestamp) return true;
  
  const cacheTime = new Date(timestamp);
  const now = new Date();
  
  // Check if it's a different day
  const isDifferentDay = cacheTime.toDateString() !== now.toDateString();
  
  return isDifferentDay;
};

// Products cache functions
export const getCachedProducts = (): any[] => {
  try {
    const cached = localStorage.getItem(PRODUCTS_CACHE_KEY);
    if (!cached) return [];
    return JSON.parse(cached);
  } catch (error) {
    console.error('Error reading cached products:', error);
    return [];
  }
};

export const setCachedProducts = (products: any[]) => {
  try {
    localStorage.setItem(PRODUCTS_CACHE_KEY, JSON.stringify(products));
    localStorage.setItem(PRODUCTS_TIMESTAMP_KEY, new Date().toISOString());
    console.log(`Cached ${products.length} products`);
  } catch (error) {
    console.error('Error caching products:', error);
  }
};

export const shouldFetchProducts = (): boolean => {
  const timestamp = localStorage.getItem(PRODUCTS_TIMESTAMP_KEY);
  if (!timestamp) return true;
  
  const cacheTime = new Date(timestamp);
  const now = new Date();
  
  // Check if it's a different day
  const isDifferentDay = cacheTime.toDateString() !== now.toDateString();
  
  return isDifferentDay;
};
